import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AbilityModule } from 'ability';
import { I18NextModule } from 'angular-i18next';
import { MbsUiKitModule, WizardModule } from 'mbs-ui-kit';
import { DownloadAndInstallComponent } from 'mbs-ui-shared@components/add-computer/steps/download-and-install/download-and-install.component';
import { ReadManualComponent } from 'mbs-ui-shared@components/add-computer/steps/read-manual/read-manual.component';
import { SelectActionComponent } from 'mbs-ui-shared@components/add-computer/steps/select-action/select-action.component';
import { DownloadBuildModule } from 'mbs-ui-shared@components/download-build/download-build.module';
import { DownloadConnectModule } from 'mbs-ui-shared@components/download-connect/download-connect.module';
import { AddComputerComponent } from './add-computer.component';

@NgModule({
  declarations: [AddComputerComponent, SelectActionComponent, DownloadAndInstallComponent, ReadManualComponent],
  exports: [AddComputerComponent, SelectActionComponent, DownloadAndInstallComponent, ReadManualComponent],
  imports: [
    CommonModule,
    I18NextModule,
    MbsUiKitModule,
    WizardModule,
    ReactiveFormsModule,
    DownloadConnectModule,
    AbilityModule,
    DownloadBuildModule
  ]
})
export class AddComputerModule {}
